export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11541.2cee3a74.jpg";